import styled from 'styled-components';

const StyledContainer = styled.div`
	transition: opacity 0.25s;
	opacity: 0;

	&.message-enter {
		opacity: 0;
	}

	&.message-enter-active,
	&.message-enter-done,
	&.message-exit {
		opacity: 1;
	}

	&.message-exit-active {
		opacity: 0;
	}
`;

const StyledMessageContainer = styled.div`
	position: absolute;
	top: 110px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;

	img {
		user-select: none;
		pointer-events: none;
	}
`;

export { StyledContainer, StyledMessageContainer };
